// extracted by mini-css-extract-plugin
export default {"root":"AdminMessage_root__slXRr"};